import { readonly } from "vue";

const Configuration = {
    common: {
        baseURL: process.env.VUE_APP_SERVER_BASE_URL
    },
    request: {
        url: process.env.VUE_APP_SERVER_GRAPHQL_URL,
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        }
    },
    images: {
        serve: process.env.VUE_APP_SERVER_BASE_URL + 'images',
        download: process.env.VUE_APP_SERVER_BASE_URL + 'images/download'
    },
    logic: {
        stillWaterLevelFrequency: 30,
        stillWaterLevelWithdrawalSpanHours: 10,
    }
}

export default readonly(Configuration);

